import { createSelector } from 'reselect'
import * as R from 'ramda'

import {
  APPROVE_TYPE
} from './constants'

const workflowIdSelector = state => state.approvals.approvalDialog.workflowId
const projectIdSelector = state => state.approvals.approvalDialog.projectId
const commentSelector = state => state.approvals.approvalDialog.comment
const activeSelector = state => state.approvals.approvalDialog.active
const typeSelector = state => state.approvals.approvalDialog.type
const typeLabelSelector = createSelector(
  typeSelector,
  R.flip(R.prop)(APPROVE_TYPE)
)
const dialogTypeSelector = state => state.approvals.approvalDialog.dialogType
const skipablesSelector = state =>  state.approvals.approvalDialog.skipables

export {
  commentSelector,
  activeSelector,
  typeSelector,
  dialogTypeSelector,
  typeLabelSelector,
  workflowIdSelector,
  projectIdSelector,
  skipablesSelector
}
